export default __webpack_public_path__ + "static/media/AnimalFeaturesSpots_04.173ac269.png";